var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "products-item" }, [
    _c(
      "a",
      {
        staticClass: "products-item__link-wrap",
        attrs: { href: _vm.productItem.Url }
      },
      [
        _c(
          "div",
          { staticClass: "products-item__inner" },
          [
            _vm.productItem.ImageHtml.Src || _vm.productItem.ImageHtml.HasCrop
              ? _c("ResponsiveImage", {
                  attrs: {
                    imageModel: _vm.productItem.ImageHtml,
                    wrapClass: "products-item__image"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "products-item__text" }, [
              _c("div", { staticClass: "products-item__text-row" }, [
                _c("h3", { staticClass: "products-item__headline" }, [
                  _vm._v(_vm._s(_vm.productItem.ListHeadline))
                ]),
                _vm._v(" "),
                _vm.productItem.HasListTeaser
                  ? _c("p", {
                      staticClass: "products-item__teaser",
                      domProps: {
                        innerHTML: _vm._s(_vm.productItem.ListTeaser)
                      }
                    })
                  : _vm._e()
              ])
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-051a5768", { render: render, staticRenderFns: staticRenderFns })
  }
}